var map = {
	"./1.png": "a4db",
	"./2-center.png": "737c",
	"./2-dash.png": "025e",
	"./2.png": "03b4",
	"./3-center.png": "2420",
	"./3-dash.png": "6a2e",
	"./3.png": "69f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7278";